module.exports = __webpack_public_path__ + "static/media/icon-tick-red.c177d488.svg";